import config from './config.js'

export default {

  messages: function(ctrl,start,count,cb_success) {
    var url = config.baseUrl + 'rest/bot/chatmsg?start=' + encodeURIComponent(start) + '&count=' + encodeURIComponent(count) + '&user=&pid=';
    config.get(ctrl,url,'Chat Nachrichten laden',cb_success);
  },

  testcmds: function(ctrl,text,cb_success) {
    console.log('testcmds: ' + text);
    config.get(ctrl,config.baseUrl + 'rest/bot/chattest?text=' + encodeURIComponent(text),'ChatBot Commands testen',cb_success);
  },

  commands: function(ctrl,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/bot/chatcmds','ChatBot Commands laden',cb_success);
  },

  savecmd: function(ctrl,cmd,cb_success) {
    config.post(ctrl,config.baseUrl + 'rest/bot/chatcmds','ChatBot Command speichern',JSON.stringify(cmd),cb_success);
  },

  delcmd: function(ctrl,id,cb_success) {
    config.delete(ctrl,config.baseUrl + 'rest/bot/chatcmds/' + encodeURIComponent(id),'ChatBot Command löschen',cb_success);
  },

  startbot: function(ctrl,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/bot/action?type=start','Chat Bot starten',cb_success);
  },

  stopbot: function(ctrl,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/bot/action?type=stop','Chat Bot stoppen',cb_success);
  },

  status: function(ctrl,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/bot/status','Chat Bot Statusabfrage',cb_success);
  },

  reload: function(ctrl,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/bot/reload','Chat Befehle erneut laden.',cb_success);
  }

}
